import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundFreeFlow from '../pages/PagePlaygroundFreeFlow'

type FreeFlowSearch = {
  runId?: string
  continueRunId?: string
  continueAssetId?: string
}

export const Route = createFileRoute('/playground/freeflow')({
  component: PagePlaygroundFreeFlow,
  validateSearch: (search: Record<string, unknown>): FreeFlowSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined,
    continueRunId:
      typeof search.continueRunId === 'string' && search.continueRunId.length > 0 ? search.continueRunId : undefined,
    continueAssetId:
      typeof search.continueAssetId === 'string' && search.continueAssetId.length > 0
        ? search.continueAssetId
        : undefined
  })
})
